import styled from "styled-components";

export const TabelaFert = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
`;